export default "__VITE_ASSET__2287db38__"